import {
  Button,
  Drawer,
  IconButton,
  Typography,
  Avatar,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useRecieverActions } from 'src/context/providers/RecieversContext';
import Map from 'src/custom_components/Map/Map';
import CountrySelect from 'src/custom_components/CountrySelect/CountrySelect';
import { countryLabel } from 'src/utils/physical-api';
import InputFieds from '../../custom_components/Froms/InputFields';
import { customerAddress, customerCreate } from './view/data';

const CustomerDrawerComponent = ({
  isDrawerOpen,
  handleDrawerToggle,
  aRow,
  setARow,
  defaultFilters,
}) => {
  const { updateReciever, updatePersonalAddress } = useRecieverActions();
  // eslint-disable-next-line
  const [filters, setFilters] = useState({
    ...defaultFilters,
  });
  // init from aRow (no useEffect)
  const [userData, setUserData] = useState({
    first_name: aRow.first_name || '',
    last_name: aRow.last_name || '',
    id_number: aRow.id_number || '',
    email: aRow.email || '',
    phone: aRow.phone || '',
    phone_secondary: aRow.phone_secondary || '',
    isPrimary: !!aRow.isPrimary,
    marketing_permissions: !!aRow.marketing_permissions,
    country: aRow.country || '',
  });

  const [userAddressInfo, setUserAddressInfo] = useState({
    address1: aRow?.personalAddress?.[0]?.address1 || '',
    address2: aRow?.personalAddress?.[0]?.address2 || '',
    city: aRow?.personalAddress?.[0]?.city || '',
    zipCode: aRow?.personalAddress?.[0]?.zipCode || '',
    state: aRow?.personalAddress?.[0]?.state || '',
    lat: aRow?.personalAddress?.[0]?.lat ?? null,
    long: aRow?.personalAddress?.[0]?.long ?? null,
    additionalInstructions: aRow?.personalAddress?.[0]?.additionalInstructions || '',
  });

  // map center (ONLY lat/lng)
  const initialMapLocation = useMemo(() => {
    const lat = aRow?.personalAddress?.[0]?.lat;
    const lng = aRow?.personalAddress?.[0]?.long; // your API uses "long"
    if (lat != null && lng != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng))) {
      return { lat: Number(lat), lng: Number(lng) };
    }
    return undefined; // create mode -> Map can geolocate/fallback
  }, [aRow]);

  const hasSavedAddress = Boolean(
    aRow?.personalAddress?.[0]?.lat && aRow?.personalAddress?.[0]?.long
  );

  // merge helper: only overwrite with real values
  const mergeNonEmpty = (prev, next) => {
    const out = { ...prev };
    Object.entries(next || {}).forEach(([k, v]) => {
      const isNum = typeof v === 'number' && Number.isFinite(v);
      const isNonEmptyStr = typeof v === 'string' && v.trim() !== '';
      const isTruthyOther = v !== null && v !== undefined && typeof v !== 'string';
      if (isNum || isNonEmptyStr || isTruthyOther) out[k] = v;
    });
    return out;
  };

  const UpdateCustomerData = () => {
    if (
      !userData.first_name ||
      !userData.last_name ||
      !userData.id_number ||
      !userData.email ||
      !userData.phone ||
      !userAddressInfo.address1 ||
      !userAddressInfo.city ||
      !userData.country
    ) {
      alert('Please fill all required fields');
      return;
    }

    updateReciever(aRow.id, {
      first_name: userData.first_name,
      last_name: userData.last_name,
      id_number: userData.id_number,
      email: userData.email,
      phone: userData.phone,
      phone_secondary: userData.phone_secondary,
      isPrimary: !!userData.isPrimary,
      marketing_permissions: !!userData.marketing_permissions,
      country: userData.country,
    });

    // receivers: update address if it exists
    if (aRow?.personalAddress?.[0]) {
      updatePersonalAddress(
        aRow.personalAddress[0].id,
        { ...userAddressInfo, country: countryLabel(userData.country) },
        filters
      );
    }

    handleDrawerToggle();
    setARow({});
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.1)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    display: isDrawerOpen ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleBackdropClose = () => {
    handleDrawerToggle();
    setARow({});
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Close customer drawer"
      style={containerStyle}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleBackdropClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === 'Escape') handleBackdropClose();
      }}
    >
      <Drawer
        variant="persistent"
        anchor="right"
        open={isDrawerOpen}
        onClose={handleBackdropClose}
        PaperProps={{ sx: { width: { lg: '40%', xs: '100%' } } }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: 20,
            borderBottom: '1px solid rgba(220,220,220,0.2)',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <Avatar>{userData?.first_name?.[0]?.toUpperCase() || ''}</Avatar>
            <Typography variant="h6">
              {userData.first_name} {userData.last_name}
            </Typography>
          </div>
          <IconButton onClick={handleBackdropClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </div>

        <Typography variant="h8" style={{ padding: '4px 20px 0px', color: 'green' }}>
          Customer - {aRow?.customer?.first_name} {aRow?.customer?.last_name}
        </Typography>
        {/* User info */}
        <InputFieds
          userData={userData}
          heading="User Information"
          inputFields={customerCreate}
          setUserData={setUserData}
        />

        <div style={{ width: '94%', margin: 'auto', padding: '20px' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!userData.isPrimary}
                onChange={(e) => setUserData((prev) => ({ ...prev, isPrimary: e.target.checked }))}
              />
            }
            label="Primary"
          />
        </div>
        <div style={{ padding: '0 0 10px 20px' }}>
          <CountrySelect
            required
            value={userData.country}
            onChange={(value) => setUserData((prev) => ({ ...prev, country: value }))}
            helperText={
              aRow.country ? '' : 'Country not set: this receiver is hidden in Create Order until it is set'
            }
          />
        </div>

        {/* Map */}
        <Map
          key={aRow?.id || 'new'} // force re-init when row changes
          initialLocation={initialMapLocation} // {lat,lng} or undefined
          suppressInitialEmit={hasSavedAddress} // don't overwrite on mount in edit mode
          onLocationChange={(loc) => setUserAddressInfo((p) => mergeNonEmpty(p, loc))}
        />
        <div style={{ marginTop: '20px' }}>
          <InputFieds
            userData={userAddressInfo}
            heading=""
            inputFields={customerAddress}
            setUserData={setUserAddressInfo}
          />
        </div>

        {/* Update */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: 20,
            borderTop: '1px solid rgba(220,220,220,0.2)',
          }}
        >
          <Button variant="contained" onClick={UpdateCustomerData}>
            Update
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

CustomerDrawerComponent.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  aRow: PropTypes.object.isRequired,
  setARow: PropTypes.func.isRequired,
  defaultFilters: PropTypes.object.isRequired,
};

export default CustomerDrawerComponent;
